<ion-header xmlns="http://www.w3.org/1999/html">
  <ion-toolbar style="--background: #00205b">
    <ion-buttons (click)="open()"   slot="start">
      <ion-menu-button  style="display:flex" color="light"></ion-menu-button>
    </ion-buttons>

    <div
      class="ml-3.5 px-2 sm:px-6 lg:px-20 flex justify-between items-center py-3"
    >
      <div class="relative flex items-center justify-between">
        <div
          class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start"
        >
          <div (click)="gotoHome()" class="cursor-pointer">
            <img class="w-[40%]"  src="/assets/trademark/teleflex.png" alt="Teleflex" />
            <h1 style="color:white" class="pt-1 font-bold">Product Performance Evaluation</h1>
          </div>
        </div>
      </div>
      <div>
        <div  class="md:hidden flex relative ">
           <ion-icon
           (click)="gotoMessages()"
          class="px-2 min-h-[25px] min-w-[25px]"
          color="light"
          name="mail"
        ></ion-icon>
        <!-- <ion-icon
        (click)="gotoNotifications()"
          class="px-2 pr-3 h-[20px] w-[20px]"
          color="light"
          name="notifications"
        ></ion-icon> -->
      </div>
        <div  class="hidden  relative md:flex items-center">
          <ion-icon
          (click)="gotoMessages()"
          class="px-2 h-[20px] w-[20px] cursor-pointer"
          color="light"
          name="mail"
        ></ion-icon>
        <!-- <ion-icon
        (click)="gotoNotifications()"
          class="px-2 pr-3 h-[20px] w-[20px]"
          color="light"
          name="notifications"
        ></ion-icon> -->
          <img
            *ngIf="auth.UserObj?.avatar"
            class="h-8 w-8 rounded-full"
            src="{{ auth.UserObj.avatar }}"
          />

          <img
            (click)="presentPopover($event)"
            class="px-1 cursor-pointer"
            src="/assets/icon/dropdown.png"
            alt="header-dropdown"
          />

          <ion-text
            *ngIf="auth.UserObj?.username"
            class="md:flex text-[#73B5F3] pl-3 px-2"
            >{{ auth.UserObj?.username }}</ion-text
          >
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
